import { Card, CollapsibleCard, DocumentLineIcon, Empty, Icon, RichTextRenderer } from 'ui';
import { isMongoObjectId } from 'common/utils';
import { Translation } from 'features/translations';

type P = {
  eventId: string;
  htmlContent?: null | string;
};

const EventDetailDescription = ({ eventId, htmlContent }: P) => (
  <CollapsibleCard
    card={{
      className: 'event-detail-description',
      title: <Card.Title icon={<DocumentLineIcon />}>Description</Card.Title>,
    }}
  >
    {htmlContent ? (
      <>
        <RichTextRenderer data={htmlContent} marginTop={false} />
        {isMongoObjectId(eventId) ? null : <Translation id={eventId} type="event" />}
      </>
    ) : (
      <Empty
        description={{
          subtitle: 'This event doesn’t have a description yet',
          title: 'No Description Available',
        }}
        image={<Icon icon="inbox-line" />}
      />
    )}
  </CollapsibleCard>
);

export default EventDetailDescription;
